import React from 'react'
import LineSvg from 'assets/img/Icon/Line.svg';

const Outlink = ({ lab, isMobile }) => {
	if (!lab || !lab.pathname) { return null; }

	let href = null,
		txt 	 = '',
		icon	 = '';

	switch (lab.pathname) {
		// case 'bon-growthstrategy':
		//
		// 	break;
		//
		// case 'camper-htstrategy':
		//
		// 	break;
		//
		// case 'modifiedvalue':
		//
		// 	break;

		case 'stocksardine-strategy':
			href = 'https://bit.ly/32lMRYe';
			txt  = '專屬社團';
			icon = 'facebook-square';

			break;

		case 'winnerstrategy':
			href = 'https://reurl.cc/N6ovex';
			txt  = '教學影片';
			icon = 'youtube';

			break;

		case 'lynch-tengrower':
			href = 'https://line.me/ti/g2/FYYUqqcIWJOWJ8e0xCIGR5T4DF7yd0BDPx4YPw';
			txt  = 'LINE 討論群';
			icon = 'line';

			break;

		case '888stockpicker':
			href = 'https://liff.line.me/1645278921-kWRPP32q/?accountId=xtm5969p';
			txt  = '888 LINE 客服';
			icon = 'line';

			break;

		default:

	}

	const lineIcon = <img src={LineSvg} className='manual-link-icon' alt="line-icon"/>;

	return (href
		?
		<a
			className="manual-link"
			href={href}
			target="_blank"
			rel="nofollow noopener noreferrer"
		>
			<div className="manual-link-txt">
				{(!isMobile && icon === 'line') && lineIcon}
				{isMobile ?
					(icon === 'line' ? lineIcon : <i className={`fab fa-${icon}`}/>) : txt
				}
			</div>
		</a>
		:
		href);
}


export { Outlink }
